import { Component } from '@angular/core';
import { HeaderComponent } from '../header/header.component';
import { SideNavigationMenuComponent } from '../side-navigation-menu/side-navigation-menu.component';
import { UtilitiesService } from '../../services/utilities.service';

@Component({
  selector: 'app-nav-interface',
  standalone: true,
  imports: [
    SideNavigationMenuComponent,
    HeaderComponent
  ],
  templateUrl: './nav-interface.component.html',
  styleUrl: './nav-interface.component.scss'
})
export class NavInterfaceComponent {
  constructor(private utilities: UtilitiesService) {
    this.utilities.isfullPage = false;
  }

}
